import React, { Component } from 'react';

import { Modal } from 'antd';

import SendFileForm from '../send-file-form/send-file-form';

import './SendDialog.less';

export default class SendDialog extends Component {
  render() {
    const { rootContainer } = this.props;

    return (
      <Modal
        getContainer={rootContainer}
        destroyOnClose={true}
        width="1200px"
        open={true}
        title="Send File"
        bodyStyle={{ padding: 0 }}
        onCancel={this.props.onHide}
        footer={null}
      >
        <SendFileForm {...this.props} />
      </Modal>
    );
  }
}
